// import { fromJS } from 'immutable';
import * as CheckoutConstants from '../FuncComp/Constants';
import * as Constants from './Constants';

const initialState = {
  updateContactInfo: false,
  updateShippingAdressflag: false,
  isInvalidAddressError: false,
  updateShippingAdressResponse: {},
  updateShippingAdressErrorResponse: {},
  marketDetails: {},
  apiFailureError: false,
  isInvalidOTP: false,
  updateValidateOTPResponse: {},
  shippingInvalidError: false,
  ISPUzipCode: '',
  shippingServiceInfo: null,
  shippingInfoError: false,
  shippingInfoNtfyMsg: null,
  showIspuStoreError: false,
  storeListUpdated: false,
  shippingAddress2UnitItems: 0,
  shippingAddress2UnitArray: [],
  shippingAddressEdit: false,
  shippingAddressRadio: '',
  showPickupInfoTab: false,
  ISPUSelectedStoreFromModel: null,
  hideWhwISpuModal: true,
  selectOtherOption: false,
  otpValidated: '',
  otpSendEmailSuccess: false,
  sendOtpError: '',
  // isInvalidEmailOTP: false,
  verifyOtpSuccess: false,
  verifyOtpError: '',
  CLEAR_UNIT2: false,
  showISPUWHWModal: false,
  uspsskipAddressValidated: false,
  selectedShippingOptionSuccess: false,
  whwUpdateAddress: false,
  isApiUpdateShippingAddressStatus: null,
  isApiUpdateShippingSuccess: false,
};

function shippingInfo(state = initialState, action) {
  // debugger;
  switch (action.type) {
    case Constants.GET_DATA_SUCCESS:
      return { ...state, title: action.response && action.response.data };
    case Constants.GET_DETAILS_FROM_API_SUCCESS:
      return { ...state, ShippingInfoDetails: action.response };
    case Constants.GET_SLOTS_SDD_SUCCESS:
      return { ...state, sddSlots: action.response };
    case Constants.GET_ENABLED_DEVICES_SUCCESS:
      return { ...state, securePinData: action.response };
    case 'CLEAR_DEVICES_STORE':
      return { ...state, securePinDataDeviceSucess: {} };
    case Constants.FETCH_SMS_DEVICES_SUCCESS:
      return {
        ...state,
        securePinDataDeviceSucess: {
          ...state.securePinDataDeviceSucess, // Preserve existing values
          ...action.response, // Add or update new values
        },
        isInvalidOTP: false,
        isFetchSMSEnabledDevices: true,
        ...action.commonData,
      };
    case Constants.CODE_VALIDATION_SUCCESS:
      return { ...state, otpSuccess: action.response };
    case Constants.CODE_VALIDATION:
      return { ...state, otpValidated: action.otp };
    case Constants.GET_SEND_SMS_SUCCESS:
      return { ...state, getSmsSuccess: action.response };
    case Constants.UPDATE_SHIPPING_ADDRESS_SUCCESS:
      return { ...state, updateShippingAdressResponse: action.response, isInvalidAddressError: false };
    case 'INVALID_ADDRESS':
      return { ...state, isInvalidAddressError: true, updateShippingAdressResponse: action.response, shippingServiceInfo: action.serviceinfo };
    case 'CLEAR_INVALID_RESPONSE':
      return { ...state, isInvalidAddressError: false };
    case 'CLEAR_SHIPPING_ERROR_STATE':
      return { 
        ...state, 
        isInvalidAddressError: false, 
        updateShippingAdressErrorResponse: {},
        apiFailureError: false,
        shippingInfoError: false,
      };
    case 'CLEAR_SHIPPING_OTP_EXIPIRE':
      return { ...state, AUTH_CODE_VERIFICATION_ERROR: '' };
    // GET_SEND_SMS_SUCCESS
    case 'CITY_AND_STATE_SUCCESS':
      return { ...state, marketDetails: action.response };
    case 'CLEAR_MARKET_DETAILS':
      return { ...state, marketDetails: {} };
    case 'SELECTED_SHIPPING_VALUE': {
      const storeUpdate = action.selectedValue !== 'ISPU' ? { ispuStoreInfo: null } : {};
      return { ...state, selectedValue: action.selectedValue, ...storeUpdate };
    }
    case 'UPDATE_SAVE_SELECTED_OPTION':
      return { ...state, selectedShippingOption: action.data };
    case CheckoutConstants.UPDATE_SAVE_SELECTED_OPTION_SUCCESS:
        return { ...state, selectedShippingOptionSuccess: action.response };
    case Constants.UPDATE_ADRESS_SUUCESS: {
      const preState = state.updateShippingAdressflag;
      return { ...state, updateShippingAdressflag: !preState };
      // return { ...state, updateShippingAdressflag: true };
    }
    case 'CLEAR_UNIT2': {
      return { ...state, CLEAR_UNIT2: action.data };
    }
    // UPDATE_ADRESS_SUUCESS
    case 'CEF_ISPU_STORES_RECEIVED':
      return {
        ...state,
        showIspuStoreError: action.response,
      };
    case 'ISPU_STORES_RECEIVED':
      return {
        ...state,
        storeList: action.response,
        isFetching: false,
        itemAvailableStores: action.itemAvailableStoresList,
      };
    case 'ISPU_STORES_UPDATED':
      return {
        ...state,
        storeListUpdatedValue: action.response,
      };

    case 'ISPU_FETCHING':
      return {
        ...state,
        storeList: [],
        isFetching: true,
      };
    case 'UPDATE_ISPU_SHIPPING_OPTION_RECIEVED':
      return { ...state, cart: action.response.cartVo.data.cart };
    case Constants.UPDATE_ISPU_STORE_INFO:
      return { ...state, ispuStoreInfo: action.response };
    // UPDATE_CONTACT_SUCCESS
    case 'UPDATE_CONTACT_SUCCESS': {
      const preState = state.updateContactInfo;
      // return { ...state, updateSetup: !preState };
      return {
        ...state,
        contactSuccess: action.response,
        updateContactInfo: !preState,
      };
    }
    case 'TOGGLE_CONTACT_SUCCESS':
      return { ...state, updateContactInfo: false };
    case 'PAYMENT_SKIP_CALL':
      return { ...state, paymentSkipCall: action.value };
    case 'REMOVED_WHWPLUS':
      return { ...state, removedWHWPlus: true };
    case Constants.UPDATE_SHIPPING_ADDRESS_ERROR: {
      // More comprehensive error checking to prevent false positives
      const hasActualError = !!(
        action.response &&
        (
          // Check for non-empty errors array with actual error content
          (action.response.errors?.length > 0 && 
           action.response.errors.some((error) => 
             error && (error.message || error.id || error.code || error.errorMessage)
           )) ||
          // Check for direct error property
          action.response.error ||
          // Check for errorMessage property
          action.response.errorMessage ||
          // Check for failed service header status
          (action.response.serviceHeader && 
           action.response.serviceHeader.statusMsg && 
           action.response.serviceHeader.statusMsg !== 'SUCCESS' &&
           action.response.serviceHeader.statusCode &&
           action.response.serviceHeader.statusCode !== '00')
        )
      );

      return {
        ...state,
        updateShippingAdressErrorResponse: action.response || {},
        isInvalidAddressError: hasActualError,
      };
    }
    case 'REMOVE_WHWPLUS':
      return { ...state, removedWHWPlus: false };
    case 'OTHER_OPTIONS_SELECTED':
      return { ...state, selectOtherOption: true };
    case 'SELECTED_OTHER_SHIPPING':
      return { ...state, selectOtherOption: false };
    case 'EXPRESS_STORE_SELECTED':
      return { ...state, selectedExpressCheckout: action.response };
    case 'EXPRESS_STORE_UPDATED':
      return { ...state, selectedExpressCheckout: action.response };
    case 'IS_BTA_ELIGIBLE':
      return { ...state, isBTAEligible: action.value };
    case Constants.GET_SHIPPING_OPTION_HEADER:
      return { ...state, shippingHeader: action.value };
    case Constants.ERR_OCCURED:
      return { ...state, apiFailureError: action.errorShipping, shippingServiceInfo: action.serviceinfo };
    case Constants.SET_ISPU_MODAL:
      return { ...state, openISPUModal: true };
    case Constants.RESET_ISPU_MODAL:
      return { ...state, openISPUModal: false };
    case Constants.SHIPPING_FETCH_SMS_DEVICES_ERROR:
      return { ...state, updateValidateOTPResponse: action.response };
    case Constants.SHIPPING_INVALID_CASE_ERROR:
      return { ...state, shippingInvalidError: action.response, shippingServiceInfo: action.serviceinfo };
    case 'ISPU_ZIPCODE':
      return { ...state, ISPUzipCode: action.response };
    case 'EMAIL_VALIDATION':
      return { ...state, emailAPiResponse: action.response, accMainEmailVal: action.response.accMainEmailVal };
    case Constants.ACC_MAIN_EMAIL_VALIDATION:
      return { ...state, accMainEmailVal: action.response };
    case Constants.CEF_SHIPPING_INFO_ERROR:
      return { ...state, shippingInfoError: action.response, shippingInfoNtfyMsg: action.errorMessage };
    case 'SHIPPING_ADDRESS2_UNIT_ITEMS':
      return { ...state, shippingAddress2UnitItems: action.data };
    case 'SHIPPING_ADDRESS2_UNIT_ARRAY':
      return { ...state, shippingAddress2UnitArray: action.data };
    case 'SHIPPING_ADDRESS_CHANGE':
      return { ...state, shippingAddressEdit: action.data };
    case 'SHIPPING_ADDRESS_RADIO_SELECTED':
      return { ...state, shippingAddressRadio: action.data };
    case 'SHOW_PICKUP_INFO':
      return { ...state, showPickupInfoTab: action.data };
    case 'DATA_SELECTED_FROM_ISPU_MODEL':
      return { ...state, dataSelectedFromISPUModel: true, ISPUSelectedStoreFromModel: action.response };
    case Constants.SEND_OTP_RESPONSE:
      return { ...state, otpSendEmailSuccess: action.response };
    case Constants.VERIFY_OTP_RESPONSE:
      return { ...state, verifyOtpSuccess: action.response };
    case 'OPEN_WHW_ISPU_MODAL':
      return { ...state, showISPUWHWModal: action.value };
    case Constants.UPDATE_SHIPPING_ADRESS_STATUS:
      return { ...state, isApiUpdateShippingAddressStatus: action.response };  
    case Constants.UPDATE_SHIPPING_ADRESS_SUCCESS:
      return { ...state, isApiUpdateShippingSuccess: action.response };
    case 'USPS_SHIPPING_ADDRESS_VALIDATED':
      return { 
        ...state, 
        uspsskipAddressValidated: action.value,
        isInvalidAddressError: action.value ? false : state.isInvalidAddressError,
        updateShippingAdressErrorResponse: action.value ? {} : state.updateShippingAdressErrorResponse,
      };
      case Constants.WHW_SHIPPING_ADDRESS_STATUS:
        return {...state, whwUpdateAddress: action.value };
  
    default:
      return state;
  }
}

export default shippingInfo;
